import clsx from 'clsx';
import { isEmpty, round } from 'lodash';
import { bool } from 'prop-types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon, Skeleton, useCartContext } from 'components';

const ExpirationTimer = ({ clockOnly = false }) => {
  const { t } = useTranslation();
  const { cart, cartLoading, timeRemaining } = useCartContext();
  const timerBelow5Minutes = useMemo(() => timeRemaining <= 300, [timeRemaining]);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = round(time % 60);
    return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
  };

  return (
    <>
      {!clockOnly && (
        <>
          {cartLoading && <Skeleton classNames="h-10 w-26" />}

          {!cartLoading && !isEmpty(cart) && timeRemaining > 0 && (
            <div className="flex gap-3 items-center" data-test-id="timer">
              <Icon
                name="hourglass-start"
                classes={`h-6 ${timerBelow5Minutes ? 'text-red-500' : 'text-yellow-500'}`}
                iconStyle="fad"
              />
              <p className="text-sm	">
                {t('cart:expiration')} :{' '}
                <span className={clsx(timerBelow5Minutes ? 'text-red-500' : 'text-yellow-500')}>
                  {formatTime(timeRemaining)}
                </span>
              </p>
            </div>
          )}
        </>
      )}

      {clockOnly && timeRemaining > 0 && (
        <div
          data-test-id="clock-timer"
          className={clsx(
            'bg-white border px-1 rounded-xl text-sm absolute -bottom-5 left-1/2 -translate-x-1/2',
            timerBelow5Minutes ? 'text-red-500 border-red-500' : 'border-yellow-500 text-yellow-500'
          )}
        >
          {formatTime(timeRemaining)}
        </div>
      )}
    </>
  );
};

ExpirationTimer.propTypes = {
  clockOnly: bool
};

export default ExpirationTimer;
